































































































import { Form, FormItem, Input, Button, Select, Option } from 'element-ui'
import { Component, Ref, Vue } from 'vue-property-decorator'

@Component({
  components: {
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
  },
})
export default class ReviewForm extends Vue {
  @Ref() readonly reviewForm!: Form

  ratingHovered = 0

  form = {
    rating: 0,
    title: '',
    body: '',
    groupSize: '',
  }

  rules = {
    title: [{ required: true, message: 'Please provide a review title' }],
    body: [{ required: true, message: 'Please fill in your review' }],
    groupSize: [{ required: true, message: 'Please select an option' }],
  }

  get displayRating(): number {
    return this.ratingHovered > this.form.rating
      ? this.ratingHovered
      : this.form.rating
  }

  setRating(rating: number) {
    this.form = {
      ...this.form,
      rating,
    }
  }

  async submitReview() {
    await this.reviewForm.validate()

    this.$emit('review-submit', this.form)
  }
}
